import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=b222781e"
import script from "./ExchangeList.vue?vue&type=script&lang=js"
export * from "./ExchangeList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeList.vue?vue&type=style&index=0&id=b222781e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports